class TC_Accessibility {
    constructor () {
        this.initKeyboardOutline();
    }

    initKeyboardOutline () {
        $('body').mousedown( function() {
            $('body').attr('data-input-intent', 'mouse');
        });
          
        $('body').keydown( function(e) {
            if (e.keyCode === 9) {
                $('body').attr('data-input-intent', 'keyboard');
            }
        });
    }
}